import Event from './Event';
import LocalStorage from '../local_data';

class GetOrderInfo extends Event {
    eventName = 'oms_getOrderInfo';

    constructor() {
        super();
        this.add();
    }

    /**
     * @override
     * 
     * Event Function for Get order details
     * @param {string} data.request_id - optional - unique id for request
     * @param {string} data.action - optional - request action
     * @return void
     *  
     */
    eventFunction(data) {
        let clientId = data.client_id;
        let requestId = (data.request_id) ? data.request_id : '';
        let action = (data.action) ? data.action : '';

        if (clientId) {

            let orderDetails = new LocalStorage.OrderDetails(clientId).getData();

            if (orderDetails && orderDetails.data) {
                orderDetails = orderDetails.data;
            }

            this.onSuccessEvent({
                data: orderDetails
            },{
                'action' : action, 
                'request_id' : requestId 
            });

            if (action == 'deleteOrderInfo') {
                let newData = orderDetails;
                newData.order_info = null;
                new LocalStorage.OrderDetails(clientId).setData(newData);
            }

        } else {
            //fire error event
            this.onErrorEvent({ "message": "client_id is required", "status": 422 }, {'action' : action, 'request_id' : requestId });
        }
    }
}

export default GetOrderInfo;